import { fetchAddOnProductsByHandle } from '../../helpers/storefront';
import { formatMoney } from '@shopify/theme-currency';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';
import { useEffect, useState } from 'preact/hooks';

const CartCrossSellProduct = ({ product }) => {
  const [currentProduct, setCurrentProduct] = useState(product);
  const [selectedVariant, setSelectedVariant] = useState();
  const [selectedSize, setSelectedSize] = useState('unselected');
  const [swatches, setSwatches] = useState([]);
  const { addLineItem } = useCartContext();
  const [productTitle, setProductTitle] = useState(product.title);
  const [showSwatches, setShowSwatches] = useState(true);
  const [hasMultipleSizes, setHasMultipleSizes] = useState(false);

  useEffect(() => {
    const getProductMetafields = async () => {
      const response = await fetchAddOnProductsByHandle(product.handle);
      if (
        response?.data?.product?.productGroup?.reference?.productList
          ?.references
      ) {
        setSwatches(
          response.data.product.productGroup.reference.productList.references
            .nodes,
        );
      }
      if (response?.data?.product?.altProductTitle) {
        setProductTitle(response.data.product.altProductTitle.value);
      }

      if (response?.data?.product?.productGroup?.reference?.hideSwatches) {
        setShowSwatches(
          response.data.product.productGroup.reference.hideSwatches.value !=
            'true',
        );
      }
    };

    getProductMetafields();
  }, [product]);

  useEffect(() => {
    currentProduct.options.forEach(option => {
      if (option.name === 'Size') {
        if (option.values.length > 1) {
          setHasMultipleSizes(true);
        } else {
          setHasMultipleSizes(false);
          setSelectedSize(option.values[0]);
        }
      }
    });
  }, [currentProduct]);

  useEffect(() => {
    const variant = currentProduct.variants.find(
      v => v.option2 == selectedSize,
    );
    setSelectedVariant(variant);
  }, [selectedSize]);

  const setCurrentProductByHandle = handle => {
    const newProduct = swatches.find(swatch => swatch.handle === handle);

    const newProductObj = {
      handle: newProduct.handle,
      id: newProduct.id,
      url: `/products/${newProduct.handle}`,
      variants: newProduct.variants.nodes.map(node => ({
        id:
          typeof node.id === 'string'
            ? parseInt(node.id.split('/').pop())
            : node.id,
        available: node.availableForSale,
        option2: node.selectedOptions[1].value,
      })),
      images: [newProduct.featuredImage.url],
      options: newProduct.options,
    };

    setCurrentProduct(newProductObj);

    const variant = newProductObj.variants.find(v => v.option2 == selectedSize);
    setSelectedVariant(variant);
  };

  if (!currentProduct) {
    return null;
  }

  const cross_sell_image = currentProduct?.images?.[0]
    ? currentProduct.images[0]
    : '';

  const handleClick = () => {
    if (selectedVariant === undefined) {
      return;
    }

    addLineItem({
      items: [
        {
          id: selectedVariant.id,
          quantity: 1,
        },
      ],
    });
  };

  return (
    <div
      data-product-id={currentProduct.id}
      class="flex flex-wrap gap-4 rounded-lg bg-grey-1 px-3 py-2 xs:flex-nowrap"
    >
      <a
        href={currentProduct.url}
        class="block aspect-product-item w-16 xs:w-20"
      >
        <img src={cross_sell_image} class="size-full rounded object-cover" />
      </a>

      <div class="flex flex-1 flex-col justify-center gap-4">
        <div class="flex items-start justify-between gap-4">
          <h5 class="type-body-small type-bold">{productTitle}</h5>

          <span>{formatMoney(product.price, theme.moneyFormat)}</span>
        </div>

        <div class="flex items-end justify-between gap-4">
          <div class="flex flex-col gap-1 sm:flex-row">
            {swatches.length > 0 && (
              <div>
                <select
                  class="type-body-xsmall h-auto w-28 py-1.5 pl-2 pr-5"
                  aria-label="Color"
                  onChange={e => {
                    setCurrentProductByHandle(e.target.value);
                  }}
                  value={currentProduct.handle}
                >
                  {showSwatches ? (
                    swatches.map(swatch => (
                      <option key={swatch.id} value={swatch.handle}>
                        {swatch.options[0].values[0]}
                      </option>
                    ))
                  ) : (
                    <option value={currentProduct.handle}>
                      {currentProduct.options[0].values[0]}
                    </option>
                  )}
                </select>
              </div>
            )}

            <div>
              <select
                class="type-body-xsmall h-auto w-28 py-1.5 pl-2 pr-5"
                aria-label="Size"
                value={selectedSize}
                onChange={e => {
                  setSelectedSize(e.target.value);
                }}
              >
                {hasMultipleSizes && (
                  <option value="unselected" disabled>
                    Select a Size
                  </option>
                )}
                {currentProduct.variants.map(variant => (
                  <option key={variant.id} value={variant.option2}>
                    {variant.option2}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button
            onClick={handleClick}
            class="button button--primary button--small type-body-xsmall type-bold whitespace-nowrap"
            disabled={!selectedVariant?.available}
          >
            <span>
              {!selectedVariant
                ? getTranslation('mini_cart.add')
                : !selectedVariant.available
                ? getTranslation('mini_cart.sold_out')
                : getTranslation('mini_cart.add')}{' '}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartCrossSellProduct;
